<template>
    <section class="ad-sec2">
        <div v-if="width > 1024" class="ad-sec2-bg"></div>
        <div class="ad-sec2-container">
            <div class="ad-sec2-img">
                <div class="rotating-border"></div>
                <img :src="imageSrc" alt="" class="main-image" />
            </div>
            <p>{{count}}</p>
            <p>{{text}}</p>
        </div>
    </section>
</template>

<script>
import { inject } from 'vue';
export default {
    name: "AdSection2",
    props: {
        imageSrc: {
          type: String,
          required: true
        },
        count: {
          type: String,
          required: true
        },
        text: {
          type: String,
          required: true
        },
      },
    setup() {
        const width = inject('viewportWidth');

        return {
            width,
        }

    }
};
</script>

<style scoped>
.ad-sec2 {
    height: 44vh;
    max-height: 461px;
}

.ad-sec2,
.ad-sec2-img {
      position: relative;
}

.ad-sec2-bg {
    height: 65%;
    max-height: 299px;
    bottom: 0;
    background-image: url('../assets/images/section-bg-4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.ad-sec2-bg,
.ad-sec2-container,
.main-image {
    position: absolute;
}

.ad-sec2-bg,
.rotating-border,
.main-image {
    width: 100%;
}

.ad-sec2-container {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    width: calc(100% - 51.668%);
    margin-inline: 25.834%;
    top: 27%;
    left: 0;
    right: 0;
    border-radius: 50px;
}

.ad-sec2-img {
    aspect-ratio: 1 / 1;
    width: 23.87%;
    max-width: 152px;
    top: -38.6%;
}

.rotating-border {
    border-radius: 20px;
}

.rotating-border,
.main-image {
    height: 100%;
}

.rotating-border::before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    z-index: -1;
    background: linear-gradient(#F8BBD0 0%, #FFFFFF 50%, #F8BBD0 100%);
    border-radius: 21px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
    padding: 1px;
    animation: rotate 5s linear infinite;
}

.main-image {
    object-fit: contain;
    top: 0;
}

.ad-sec2-container::before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    z-index: -1;
    background: linear-gradient(
    90deg,
    rgba(248, 187, 208, 0) 0%,
    rgba(248, 187, 208, 1) 50%,
    rgba(248, 187, 208, 0) 100%
    );
    border-radius: 51px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
    padding: 1px;
    box-shadow: 0 2px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
}

.ad-sec2-container > p:first-of-type {
    font-size: 32px;
    color: var(--main-pink);
    text-align: center;
    margin-bottom: 5px;
}

.ad-sec2-container > p:last-of-type {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
}

.ad-sec2-container p {
     animation: fadeIn 3s ease-out forwards;
}

@media screen and (min-width:1441px) {
    .ad-sec2-container {
        width: 720px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .ad-sec2-container > p:first-of-type {
        font-size: 24px;
    }

    .ad-sec2-container > p:last-of-type {
        font-size: 20px;
    }
}

@media screen and (max-width: 768px) {
    .ad-sec2-container {
        margin-inline: 15.03%;
        width: calc(100% - 30.06%);
        border-radius: 32px;
    }

    .ad-sec2-container::before {
        border-radius: 32px;
    }

    .ad-sec2-container > p:last-of-type {
        font-size: 18px;
    }
}

@media screen and (max-width: 360px) {
    .ad-sec2 {
        max-height: 201px;
    }

    .ad-sec2-container {
        margin-inline: 9.03%;
        width: calc(100% - 18.06%);
        top: 20%;
    }

    .ad-sec2-img {
        width: 27.13%;
    }

    .ad-sec2-container > p:last-of-type {
        margin-bottom: 10px;
    }
}
</style>